import Link from 'next/link';
import type { ReactNode } from 'react';
import styled from 'styled-components';

import { cardBackround } from '@/styles/shared';

export const ContentWrapper = styled.div<{
  children: ReactNode;
  className?: string;
}>`
  ${cardBackround};
  padding: 12px;
  margin-bottom: 30px;

  p {
    line-height: 1.7;
  }

  @media ${({ theme }) => theme.media.tablet} {
    padding: 40px 50px;
  }

  ul {
    list-style: unset;
    margin: 12px 0;
    padding-left: 32px;

    li {
      margin-bottom: 10px;
      line-height: 1.5;
    }
  }

  ol {
    margin: 12px 0;
    padding-left: 32px;

    li {
      margin-bottom: 10px;
      line-height: 1.5;
    }
  }
`;

export const TopSectionWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 15px;
  row-gap: 10px;
`;

export const Date = styled.p`
  margin: 5px 0 0 0;
  font-size: 14px;
  font-family: Montserrat, Helvetica, sans-serif;
  font-weight: 500;
`;

export const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  & a:not(:first-of-type) > div {
    background: white;
    border: 1px solid ${({ theme }) => theme.palette.primary};
    color: ${({ theme }) => theme.palette.dark};
  }
`;

export const PostContentWrapper = styled.div`
  & * {
    max-width: ${({ theme }) => theme.contentMaxWidth};
    font-family: Roboto, Helvetica, sans-serif;
  }

  h2 {
    margin-top: 36px;

    @media ${({ theme }) => theme.media.tablet} {
      margin-top: 48px;
    }
  }
`;

export const PreviewButton = styled(Link)`
  position: sticky;
  bottom: 10px;
  left: 100%;
  background: ${({ theme }) => theme.palette.lightGray};
  border-radius: 30px;
  padding: 10px 20px;
  color: black;
  z-index: 200;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  aspect-ratio: 1/1;
  position: relative;
`;
